import Header from '../LandingPage/components/Header';
import Footer from '../LandingPage/components/Footer';
import Testimonials from '../LandingPage/components/Testimonials';
import { Outlet } from '@remix-run/react';

export default function Layout() {
    return (
        <div className='bg-gray-50'>
            <Header />
            <Outlet />
            <Testimonials />
            <Footer />
            <script
                async
                src='//perfectwiki.page/widget.js'
                data-organization-id='89c663c2-211c-4e7c-834c-b945c28cc308'
                data-channel-id='19:7e0c265431ed41eead9dab019239829f@thread.tacv2'></script>
        </div>
    );
}
